import React from "react";
import SEO from "../components/SEO";

const BusinessSolutions = () => {
  return (
    <>
      <SEO slug="BusinessSolutions" />
    </>
  );
};

export default BusinessSolutions;
